import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCalendarDays, FaTag } from "react-icons/fa6";
import PageHero from "../components/pageHero";
import InsightsDashboardGraphic from "../images/graphics/insights-dashboard.svg";
import { buildApiUrl, buildAssetUrl } from "../utils/api";

function BlogMarketplace() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(buildApiUrl("/api/blogs"));
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <Helmet>
        <title>Insights | 3PL Search</title>
      </Helmet>

      <div className="blog-page">
        <PageHero
          eyebrow="Insights and education"
          title="Content that supports warehouse selection, quoting, and logistics decisions."
          description="The blog now fits the same visual system as the rest of the site and avoids repeated, generic card content."
          image={InsightsDashboardGraphic}
          imageAlt="Insights dashboard infographic"
          imageLight
        />

        <section className="content-section">
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow-badge">Latest posts</span>
              <h2>Browse practical 3PL and warehouse insight content.</h2>
            </div>

            {loading ? <div className="page-loader">Loading insights...</div> : (
              <div className="row g-4">
                {blogs.map((blog) => (
                  <div className="col-md-6 col-xl-4" key={blog._id}>
                    <div className="market-card h-100">
                      {blog.image?.[0] ? (
                        <img className="blog-card-image" src={buildAssetUrl(blog.image[0])} alt={blog.title} />
                      ) : (
                        <img className="blog-card-image" src={InsightsDashboardGraphic} alt="Insight graphic" />
                      )}
                      <h3>{blog.title}</h3>
                      <div className="market-card-meta">
                        <p><FaCalendarDays /> {new Date(blog.date).toLocaleDateString()}</p>
                        <p><FaTag /> {blog.tags}</p>
                      </div>
                      <p className="market-card-copy">{blog.description}</p>
                      <div className="market-card-actions">
                        <Link className="site-primary-cta" to={`/blog/${blog._id}`}>Read article</Link>
                        <span className="text-link">Insight-led buying support <FaArrowRight /></span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
}

export default BlogMarketplace;
